import { createFileRoute } from '@tanstack/react-router';
import type React from 'react';
import { LibrarySearchResultsProvider } from 'src/context/LibrarySearchResultsContext';
import HomePage from 'src/HomePage/HomePage';
import { requireAuth } from 'src/utils/authGuard';
import { type BaseSearchParams, baseSearchSchema } from 'src/utils/searchSchemas';

export type LibrarySearchParams = BaseSearchParams;

const LibraryRoute = (): React.ReactElement => (
  <LibrarySearchResultsProvider>
    <HomePage />
  </LibrarySearchResultsProvider>
);

export const Route = createFileRoute('/library/')({
  validateSearch: baseSearchSchema,
  // Strip empty default values from URL to prevent serialization issues
  search: {
    middlewares: [
      ({ search, next }) => {
        const result = next(search);
        // Remove empty arrays and undefined values from serialization
        const cleaned = { ...result };
        if (Array.isArray(cleaned.filters) && cleaned.filters.length === 0) {
          delete cleaned.filters;
        }
        return cleaned;
      },
    ],
  },
  beforeLoad: () => {
    requireAuth();
  },
  component: LibraryRoute,
});
